<template>
  <div class="container mx-auto text-center p-6">
    <h1 class="text-3xl font-bold mb-6">Seasonal Membership</h1>
    <p class="text-lg">A flexible membership plan for seasonal golfers.</p>
  </div>
</template>

<style scoped>
.container {
  max-width: 800px;
}
</style>
